const menuGroupPaths = {
    settings: "/settings",
    personal: "/personal",
    performanceManagement: "/performanceManagement",
    talentAcquisition: "/talentAcquisition",
    requests: "/requests",
    remunerations: "/remunerations",
    timeManagement: "/timeManagement",
    management: "/management",
    calculationManagement: "/calculationManagement",
    positions: "/positions",
    extensibility: "/extensibility",
    engagement: "/engagement",
    organizationalDevelopment: "/organizationalDevelopment",
}

const buttonPaths = {
    absentCollaboratorsButton: "/absentCollaboratorsButton",
    aiQueryAnalysisButton: "/aiQueryAnalysisButton",
    aiQueryChatButton: "/aiQueryChatButton",
    approveCalculationProcessButton: "/approveCalculationProcessButton",
    calculateAttendanceAnalysisButton: "/calculateAttendanceAnalysisButton",
    calculateProcessAssetsDiscountsButton: "/calculateProcessAssetsDiscountsButton",
    calculateProcessIssuesButton: "/calculateProcessIssuesButton",
    calculateProcessMyPeopleButton: "/calculateProcessMyPeopleButton",
    connectedUsersButton: "/connectedUsersButton",
    employeeCurrentAccountPermissionsButton: "/employeeCurrentAccountPermissionsButton",
    myDesktopLoansButton: "/myDesktopLoansButton",
    myMedalTableButton: "/myMedalTableButton",
    openPermissionIssueRecordButton: "/openPermissionIssueRecordButton",
    openVacationIssueRecordButton: "/openVacationIssueRecordButton",
    publishToFeedButton: "/publishToFeedButton",
    registerAssistanceButton: "/registerAssistanceButton",
    utilsButton: "/utilsButton",
}

const specialPaths = {
    fiscalization: "/fiscalization",
    registerAssistanceTotem: "/registerAssistanceTotem",
    userMenu: "/userMenu", // lo usa las pantallas dinamicas
}

const gridOnlyPaths = { // para paths de grillas que no tienen path de pantalla
    catalogFields: "/catalogFields",
    notesDialog: "/notesDialog",
    currentProcessesEmployees: "/currentProcessesEmployees",
    digitalFolderAnalysisNotAvailable: "/digitalFolderAnalysisNotAvailable",
    employeesProcesses: "/employeesProcesses",
    employeesProcessesResults: "/employeesProcessesResults",
    employeesProcessesOthers: "/employeesProcessesOthers",
    employeesProcessesDetails: "/employeesProcessesDetails",
    employeesProcessesReferences: "/employeesProcessesReferences",
    queryDefinitionParameters: "/queryDefinitionParameters",
    geoQueryParameters: "/geoQueryParameters",
    myDigitalWarehouse: "/myDigitalWarehouse",
    requestControlHistorical: "/requestControlHistorical",
    loansDetailEmployer: "/loansDetailEmployer",
    loansDetailCollaborator: "/loansDetailCollaborator",
    myPendingSecondGrid: "/myPendingSecondGrid",
    myRequestsSecondGrid: "/myRequestsSecondGrid",
    vacationsDetailDebit: "/vacationsDetailDebit",
    vacationsDetailCredit: "/vacationsDetailCredit",
    showDocs: "/showDocs",
    pollReviewSentiments: "/pollReviewSentiments",
    issueSummaryMatrix: "/issueSummary/matrix",
    userTablesFieldsDefinition: "/userTablesFieldsDefinition",
    systemTablesFieldsDefinition: "/systemTablesFieldsDefinition",
    assistanceAnalysisIndividual: "/assistanceAnalysis/individual",
    training: "/training",
    familyGroup: "/familyGroup",
    distributionCost: "/distributionCost",
    historicalDistributionCost: "/historicalDistributionCost",
    collaboratorSkillsRankingSuggestedSkills: "/collaboratorSkillsRanking/suggestedSkills",
}

const screenPaths = {
    myAssistance: "/myAssistance",
    assistance: "/assistance",
    queries: "/queries",
    myPeople: "/myPeople",
    peopleMaster: "/peopleMaster",
    kpiIndicators: "/kpiIndicators",
    myQueries: "/myQueries",
    myPending: "/myPending",
    myPendingEmployer: "/myPendingEmployer",
    myDigitalFolder: "/myDigitalFolder",
    myAnnotations: "/myAnnotations",
    requestControl: "/requestControl",
    delegations: "/delegations",
    myRequests: "/myRequests",
    myRequestsManager: "/myRequestsManager",
    actions: "/actions",
    receipts: "/receipts",
    digitalReceipts: "/digitalReceipts",
    loans: "/loans",
    directory: "/directory",
    alerts: "/alerts",
    pollReview: "/pollReview",
    certificates: "/certificates",
    digitalCertificates: "/digitalCertificates",
    myPersonalData: "/myPersonalData",
    myCertificates: "/myCertificates",
    myReceipts: "/myReceipts",
    myHistoricalReceipts: "/myHistoricalReceipts",
    changeSociety: "/changeSociety",
    changeRole: "/changeRole",
    changeTheme: "/changeTheme",
    logOut: "/logOut",
    myPIN: "/myPIN",
    signers: "/signers",
    totems: "/totems",
    vacations: "/vacations",
    myVacations: "/myVacations",
    digitalSignature: "/digitalSignature",
    requestDocuments: "/requestDocuments",
    requestedDocuments: "/requestedDocuments",
    signedDocuments: "/signedDocuments",
    myGroups: "/myGroups",
    notes: "/notes",
    generalSettings: "/generalSettings",
    digitalFolderSettings: "/digitalFolderSettings",
    externalDocuments: "/externalDocuments",
    digitalDocuments: "/digitalDocuments",
    publications: "/publications",
    pollSettings: "/pollSettings",
    accessSettings: "/accessSettings",
    annotationsAnalysis: "/annotationsAnalysis",
    historicalProcesses: "/historicalProcesses",
    currentProcesses: "/currentProcesses",
    digitalFolderAnalysis: "/digitalFolderAnalysis",
    geoanalysis: "/geoanalysis",
    publicationSettings: "/publicationSettings",
    centersSettings: "/centersSettings",
    permissionsSettings: "/permissionsSettings",
    documentPublication: "/documentPublication",
    positionEditor: "/positionEditor",
    familySettings: "/familySettings",
    functionsSettings: "/functionsSettings",
    advancesSettings: "/advancesSettings",
    requestsSettings: "/requestsSettings",
    contractTypesSettings: "/contractTypesSettings",
    conceptGroups: "/conceptGroups",
    contractorSettings: "/contractorSettings",
    functionaryTypesSettings: "/functionaryTypesSettings",
    locationSettings: "/locationSettings",
    locationSettingsBox: "/locationSettingsBox",
    worksAndTasks: "/worksAndTasks",
    divisionsSettings: "/divisionsSettings",
    conceptsAndFormulasScreenSelector: "/conceptsAndFormulasScreenSelector",
    conceptsAndFormulas: "/conceptsAndFormulas",
    calculationsFunctions: "/calculationsFunctions",
    accumulatorSettings: "/accumulatorSettings",
    organizationalDefinitions: "/organizationalDefinitions",
    categoriesSettings: "/categoriesSettings",
    specialtiesSettings: "/specialtiesSettings",
    payrollTypes: "/payrollTypes",
    allergiesExamsAndDiseases: "/allergiesExamsAndDiseases",
    allergiesSettings: "/allergiesSettings",
    examsSettings: "/examsSettings",
    diseasesSettings: "/diseasesSettings",
    calculationReferences: "/calculationReferences",
    entryExitTypes: "/entryExitTypes",
    entryTypes: "/entryTypes",
    exitTypes: "/exitTypes",
    thirdPartySettings: "/thirdPartySettings",
    organizationStructure: "/organizationStructure",
    orgChart: "/orgChart",
    geographicalStructure: "/geographicalStructure",
    issueTypesSettings: "/issueTypesSettings",
    absenceTypes: "/absenceTypes",
    permissionTypes: "/permissionTypes",
    licenceTypes: "/licenceTypes",
    positionsClassification: "/positionsClassification",
    managementDefinition: "/managementDefinition",
    queryDefinition: "/queryDefinition",
    geoQuery: "/geoQuery",
    generalValues: "/generalValues",
    kpiDefinition: "/kpiDefinition",
    typesOfBenefits: "/typesOfBenefits",
    alertsSettings: "/alertsSettings",
    userAlertsSettings: "/userAlertsSettings",
    systemAlertsSettings: "/systemAlertsSettings",
    conceptStructure: "/conceptStructure",
    conceptSet: "/conceptSet",
    extraHoursAuthorization: "/extraHoursAuthorization",
    thirdPartyClassification: "/thirdPartyClassification",
    thirdParty: "/thirdParty",
    laborUnions: "/laborUnions",
    paymentTypes: "/paymentTypes",
    documentTemplates: "/documentTemplates",
    assetsDiscounts: "/assetsDiscounts",
    createAssetsDiscounts: "/createAssetsDiscounts",
    assetsDiscountsSummary: "/assetsDiscountsSummary",
    attendanceReport: "/attendanceReport",
    entryInInstallments: "/entryInInstallments",
    entryPerConceptSet: "/entryPerConceptSet",
    entryPerSociety: "/entryPerSociety",
    entryPerConcept: "/entryPerConcept",
    digitalWarehouseFileTypes: "/digitalWarehouseFileTypes",
    trainingData: "/trainingData",
    schooling: "/schooling",
    studies: "/studies",
    specializations: "/specializations",
    languages: "/languages",
    holidayTable: "/holidayTable",
    extraHoursTable: "/extraHoursTable",
    festivitiesTable: "/festivitiesTable",
    benefitsDefinitions: "/benefitsDefinitions",
    benefitsForPlans: "/benefitsForPlans",
    organizationalBenefits: "/organizationalBenefits",
    affiliationInstitutionDefinition: "/affiliationInstitutionDefinition",
    retirementDefinition: "/retirementDefinition",
    healthDefinition: "/healthDefinition",
    digitalWarehouse: "/digitalWarehouse",
    ratingsAndGeneralValues: "/ratingsAndGeneralValues",
    familyAsignations: "/familyAsignations",
    ratings: "/ratings",
    taxTable: "/taxTable",
    massEntry: "/massEntry",
    entryByImport: "/entryByImport",
    dataCapture: "/dataCapture",
    specialProcessDefinition: "/specialProcessDefinition",
    accountingImputations: "/accountingImputations",
    processScheduling: "/processScheduling",
    myDesktop: "/myDesktop",
    mySchedule: "/mySchedule",
    specialProcessExecution: "/specialProcessExecution",
    myPeopleSchedule: "/myPeopleSchedule",
    rebuildAccumulators: "/rebuildAccumulators",
    timeDefinition: "/timeDefinition",
    turnDefinition: "/turnDefinition",
    schedulesDefinition: "/schedulesDefinition",
    schedulesProgramming: "/schedulesProgramming",
    historicAccumulators: "/historicAccumulators",
    alertsTemplates: "/alertsTemplates",
    calendarDefinition: "/calendarDefinition",
    issueManagementScreenSelector: "/issueManagementScreenSelector",
    issueSummary: "/issueSummary",
    issueLicences: "/issueLicences",
    issuePermissions: "/issuePermissions",
    issueAbsences: "/issueAbsences",
    issueVacations: "/issueVacations",
    consentTypes: "/consentTypes",
    benefitsCenter: "/benefitsCenter",
    projects: "/projects",
    consentPublication: "/consentPublication",
    myApprovedConsents: "/myApprovedConsents",
    documentsScreenSelector: "/documentsScreenSelector",
    consentsScreenSelector: "/consentsScreenSelector",
    pollScreenSelector: "/pollScreenSelector",
    userTablesDefinition: "/userTablesDefinition",
    catalogs: "/catalogs",
    userTables: "/userTables",
    relatedTablesDefinition: "/relatedTablesDefinition",
    extensibilityScreenSelector: "/extensibilityScreenSelector",
    systemTablesDefinition: "/systemTablesDefinition",
    systemTables: "/systemTables",
    transactionLog: "/transactionLog",
    assistanceAnalysis: "/assistanceAnalysis",
    recognitionPlans: "/recognitionPlans",
    feedbackPurpose: "/feedbackPurpose",
    groupClassification: "/groupClassification",
    bankSettings: "/bankSettings",
    currencySettings: "/currencySettings",
    reasonForPointAwarding: "/reasonForPointAwarding",
    recognitionPlansAssignment: "/recognitionPlansAssignment",
    myBenefits: "/myBenefits",
    recognitionScreenSelector: "/recognitionScreenSelector",
    recognitionAnalysis: "/recognitionAnalysis",
    actionTypes: "/actionTypes",
    talentClassification: "/talentClassification",
    performanceEvaluations: "/performanceEvaluations",
    performanceEvaluationsCalibration: "/performanceEvaluationsCalibration",
    performanceInterviewAndFeedback: "/performanceInterviewAndFeedback",
    performanceSummaryAndResults: "/performanceSummaryAndResults",
    forms: "/forms",
    performanceForms: "/performanceForms",
    nineBoxSettings: "/nineBoxSettings",
    nineBoxClassification: "/nineBoxClassification",
    pollComparison: "/pollComparison",
    feed: "/feed",
    feedback: "/feedback",
    communicationChannel: "/communicationChannel",
    userMenus: "/userMenus",
    socialBlacklist: "/socialBlacklist",
    performanceDefinition: "/performanceDefinition",
    typesOfObjectives: "/typesOfObjectives",
    typesOfScore: "/typesOfScore",
    ratingScales: "/ratingScales",
    positionGroupsForEvaluations: "/positionGroupsForEvaluations",
    periodsForObjectives: "/periodsForObjectives",
    typesOfSkillsSpecific: "/typesOfSkillsSpecific",
    typesOfSkillsTransversal: "/typesOfSkillsTransversal",
    goalsAndObjectives: "/goalsAndObjectives",
    talentAcquisitionSettings: "/talentAcquisitionSettings",
    classificationApplicantsTypes: "/classificationApplicantsTypes",
    typesOfPublicationChannels: "/typesOfPublicationChannels",
    typesOfPublicationFormats: "/typesOfPublicationFormats",
    typesOfOnboardingActions: "/typesOfOnboardingActions",
    onboardingProfiles: "/onboardingProfiles",
    evaluationProcessDefinition: "/evaluationProcessDefinition",
    evaluationProcessDefinitionAssignment: "/evaluationProcessDefinitionAssignment",
    performanceAnalytics: "/performanceAnalytics",
    performanceAnalyticsEvaluations: "/performanceAnalyticsEvaluations",
    performanceAnalyticsTalent: "/performanceAnalyticsTalent",
    communicationClassification: "/communicationClassification",
    utils: "/utils",
    onboardingMaterials: "/onboardingMaterials",
    onboardingScreenSelector: "/onboardingScreenSelector",
    onboardingProcesses: "/onboardingProcesses",
    onboardingProcessesAssignment: "/onboardingProcessesAssignment",
    onboardingTracking: "/onboardingTracking",
    myOnboardingTracking: "/myOnboardingTracking",
    performanceAnalyticsHistoric: "/performanceAnalyticsHistoric",
    trainingAndDevelopment: "/trainingAndDevelopment",
    coursesMaster: "/coursesMaster",
    trainingDefinition: "/trainingDefinition",
    myTraining: "/myTraining",
    modulesAndMenus: "/modulesAndMenus",
    collaboratorSkillsRanking: "/collaboratorSkillsRanking",
}

const paths = {
    home: "/",
    aboutUs: "/aboutUs",
    ...specialPaths,
    ...buttonPaths,
    ...gridOnlyPaths,
    ...menuGroupPaths,
    ...screenPaths,
}

export const PATHS_TO_IGNORE_IN_SEARCH = [
    paths.recognitionPlansAssignment,
    paths.evaluationProcessDefinitionAssignment,
    paths.onboardingProcessesAssignment,
    paths.modulesAndMenus,
    paths.collaboratorSkillsRanking,
]

export const PATHS_TO_IGNORE_AS_VISITED = [
    paths.home,
    paths.myDesktop,
    paths.alerts,
    paths.locationSettingsBox,
    paths.entryExitTypes,
    paths.thirdPartySettings,
    paths.issueTypesSettings,
    paths.trainingData,
    paths.allergiesExamsAndDiseases,
    paths.organizationalDefinitions,
    paths.affiliationInstitutionDefinition,
    paths.benefitsDefinitions,
    paths.requestsSettings,
    paths.publications,
    paths.alertsSettings,
    paths.conceptsAndFormulasScreenSelector,
    paths.ratingsAndGeneralValues,
    paths.assetsDiscounts,
    paths.managementDefinition,
    paths.userMenu,
    paths.recognitionPlansAssignment,
    paths.evaluationProcessDefinitionAssignment,
]

export default paths;